import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        const r = await api.post("/auth/refresh");
        setUser(r.data);
      } catch (e) {
        setUser(false);
      }
    });
    const onExpired = () => setUser(false);
    window.addEventListener("tow-auth-expired", onExpired);
    return () => window.removeEventListener("tow-auth-expired", onExpired);
  }, []);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const Protected = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#FACC15]" /></div>;
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  return children;
};

export const STATUS_LABELS = {
  new: "New Request",
  contacted: "Customer Contacted",
  quoted: "Quote Provided",
  accepted: "Accepted",
  driver_assigned: "Driver Assigned",
  en_route: "En Route",
  completed: "Service Completed",
  cancelled: "Cancelled",
};

export const SERVICE_LABELS = {
  flatbed: "Flatbed Towing", local_tow: "Local Towing", long_distance: "Long-Distance Towing", accident: "Accident Recovery",
  flat_tire: "Flat Tire Change", spare_tire: "Spare Tire Installation", jump_start: "Jump Start / Dead Battery",
  lockout: "Car Lockout", fuel: "Fuel Delivery", winch: "Winch-Out / Stuck Vehicle", motorcycle: "Motorcycle Towing",
  transport: "Vehicle Transport", other: "Other Roadside Assistance",
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const money = (n) => (n === null || n === undefined ? "—" : `$${Number(n).toFixed(2)}`);
